// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import {
  Dropdown,
  Segment,
  Button,
  Loader,
  Label,
  Grid,
  Icon,
  Input,
  Dimmer,
  Header,
  Divider
} from 'semantic-ui-react'
import fire from '../config/Fire'
import ScrollArea from '@xico2k/react-scroll-area'
import SmartComponents from '../components/sheets/SmartComponents.js'
import UserSheet from '../components/UserSheet.js'
import ExperimentalPreview from '../components/ExperimentalPreview.js'

const trigger = (
  <span>
    <Icon size='large' name='database' />
    Select source
  </span>
)

const val1select = <span>Header</span>
const val2select = <span>Description</span>
const val3select = <span>Extra</span>
const imageSelect = <span>Image (optional)</span>

export default class ManageSheet extends Component {
  constructor (props) {
    super(props)
    this.child = React.createRef()
    this.newSmartComp = this.newSmartComp.bind(this)
    this.state = {
      done: false,
      result: [],
      components: [],
      columns: [],
      rows: [],
      sheetID: null,
      columnsLength: null,
      singleRow: false,
      newCompLabel: '',
      theme: 'wrap',
      selectComp: false,
      selectSource: false,
      selectLabel: false,
      copied: false
    }
  }
  componentDidMount = () => {
    this.setState({ loading: true })
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        const {
          match: { params }
        } = this.props
        let raw = user.email
        let userUnderscore = raw.replace(/\./g, '_')
        this.setState({
          sheetID: params.sheetid,
          userUnderscore: userUnderscore,
          loading: false
        })
        this.sheetComponents()
        this.sheetColumns()
      } else {
        this.props.history.push('/')
      }
    })
  }

  sheetComponents = (e) => {
    let userUnderscore = this.state.userUnderscore
    fetch('https://murkstomstag.herokuapp.com/api/v1/sheet/components', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sheetID: this.state.sheetID,
        userUnderscore: userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if ((json.code = 200)) {
          this.setState({
            components: json.components,
            componentsIndex: json.componentsIndex,
            active: true,
            loading: false
          })
        } else {
          this.setState({
            loading: false,
            error: json.code
          })
        }
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false })
      })
  }

  sheetColumns = () => {
    var self = this
    var request = new Request('https://sheetjson.herokuapp.com/api?id=' + this.state.sheetID)
    fetch(request)
      .then(function (result) {
        return result.json()
      })
      .then(function (result) {
        var rows = []
        var columns = []
        for (let column in result.columns) {
          columns.push({
            value: column,
            text: column,
            key: column
          })
        }
        var dataR = result.rows
        for (let row in dataR) {
          var value = dataR[row]
          rows.push({ value })
        }

        self.setState({
          columnsLength: Object.keys(result.columns).length,
          rowsLength: Object.keys(result.rows).length,
          columns: columns,
          rows: rows
        })
      })
      .catch(function (err) {
        console.log(err)
      })
  }

  saveValues = (e) => {
    this.setState({ saving: true })
    e.preventDefault()
    let { selectedValue1, selectedValue2, selectedValue3, selectedImage } = this.state
    const objUpdate = {
      selectedValue1: selectedValue1,
      selectedValue2: selectedValue2,
      selectedValue3: selectedValue3,
      selectedImage: selectedImage
    }
    const cloneObjUpdate = { ...objUpdate }
    Object.keys(objUpdate).forEach((key) => {
      if (!cloneObjUpdate[key]) cloneObjUpdate[key] = null
    })
    fetch('https://murkstomstag.herokuapp.com/api/v1/save/sheet/values', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sheetID: this.state.sheetID,
        userUnderscore: this.state.userUnderscore,
        cloneObjUpdate: cloneObjUpdate
      })
    }).then((response) => {
      if (response.status === 200) {
        this.child.current.sheetData()
        this.setState({
          saving: false
        })
      } else {
        this.setState({ error: response.status, loading: false })
      }
    })
  }

  removeSheet = () => {
    this.setState({ loading: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/remove/sheet', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore,
        sheetID: this.state.sheetID
      })
    }).then((response) => {
      if (response.status === 200) {
        this.props.history.push('/sheets')
      } else {
        this.setState({ error: response.status, loading: false })
      }
    })
  }

  newComp = (e) => {
    this.setState({ apiLoading: true })
    let { newCompLabel, newComp, compType, userUnderscore, sheetID } = this.state
    if (this.state.newCompLabel === '') {
      this.setState({ errorComp: 'Label required' })
    } else {
      fetch('https://murkstomstag.herokuapp.com/api/v1/new/sheet/comp', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userUnderscore: userUnderscore,
          sheetID: sheetID,
          compType: compType,
          newComp: newComp,
          newCompLabel: newCompLabel
        })
      }).then((response) => {
        if (response.status === 200) {
          this.sheetComponents()
          this.newCompUpdate()
          this.child.current.sheetComponents()
        } else {
          this.setState({ error: response.status, apiLoading: false })
        }
      })
    }
  }

  deleteSheetComp = (item, index) => {
    fetch('https://murkstomstag.herokuapp.com/api/v1/delete/sheet/comp', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore,
        sheetID: this.state.sheetID,
        path: this.state.componentsIndex[item].value
      })
    }).then((response) => {
      if (response.status === 200) {
        this.sheetComponents()
        this.child.current.sheetData()
      } else {
        this.setState({ error: response.status, loading: false, singleRow: true, done: false })
      }
    })
  }

  sheetLayout = (selectedTheme) => {
    fetch('https://murkstomstag.herokuapp.com/api/v1/sheet/layout', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore,
        sheetID: this.state.sheetID,
        theme: selectedTheme
      })
    }).then((response) => {
      if (response.status === 200) {
        this.setState({ theme: selectedTheme })
      } else {
        this.setState({ error: response.status, loading: false, singleRow: true, done: false })
      }
    })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleValue1 = (e, { value }) => {
    this.setState({ selectedValue1: value })
  }
  handleValue2 = (e, { value }) => {
    this.setState({ selectedValue2: value })
  }
  handleValue3 = (e, { value }) => {
    this.setState({ selectedValue3: value })
  }
  handleImage = (e, { value }) => {
    this.setState({ selectedImage: value })
  }
  handleNewComp = (e, { value }) => {
    this.setState({ newComp: value, selectLabel: true, selectSource: false })
  }

  newSmartComp = (type, e) => {
    this.setState({
      compType: type,
      selectComp: true,
      selectSource: true
    })
  }
  newCompUpdate = (e) => {
    this.setState({
      selectComp: false,
      selectSource: false,
      selectLabel: false,
      errorComp: false,
      newCompLabel: '',
      newComp: null,
      apiLoading: false
    })
  }
  clearAll = (e) => {
    this.setState({
      selectedValue1: null,
      selectedValue2: null,
      selectedValue3: null,
      selectedImage: null
    })
  }
  clearSelect = (e) => {
    this.setState({
      selectSource: false,
      selectLabel: false,
      selectComp: false,
      newComp: null
    })
  }
  confirm = () => this.setState({ confirm: true })

  singleRow = () => {
    this.setState({
      done: false,
      singleRow: true
    })
  }

  goBack = (e) => {
    this.setState({ done: true, singleRow: false, selectedIndex: null })
  }

  render () {
    let {
      loading,
      selectedValue1,
      selectedValue2,
      selectedValue3,
      selectedImage,
      columns,
      saved,
      active,
      newComp,
      errorComp,
      theme,
      confirm,
      selectComp,
      selectSource,
      selectLabel,
      saving,
      compType,
      apiLoading
    } = this.state

    const components = this.state.components.map((item, index) => (
      <Grid.Column key={index}>
        <Segment inverted fluid>
          <Grid stackable verticalAlign='middle'>
            <Grid.Column width='8'>
              <Label style={{ backgroundColor: '#555', color: '#fff' }} ribbon>
                type: {item.value.type}
              </Label>
              <br />
              <Label ribbon>source: {item.value.source}</Label>
            </Grid.Column>
            <Grid.Column width='8'>
              <Header as='h4' style={{ color: '#eee' }}>
                {item.value.label}
              </Header>
              <div className='mtbs'>
                <Button
                  size='mini'
                  compact
                  color='red'
                  onClick={() => this.deleteSheetComp(index, item)}>
                  <Icon name='trash' />
                  Remove
                </Button>
              </div>
            </Grid.Column>
          </Grid>
        </Segment>
      </Grid.Column>
    ))
    return (
      <div>
        {loading ? (
          <Dimmer page active inverted>
            <Loader>Processing...</Loader>
          </Dimmer>
        ) : null}

        <Grid reversed='computer' stackable verticalAlign='top' fluid>
          <Grid.Column width='6'>
            <div className='mt'>
              <div className='newframe'>
                <div className='newframe-content'>
                  <div className='containerX' />
                  <div className='newframe-content-body'>
                    {!loading && (
                      <UserSheet
                        singleRow={this.singleRow}
                        goBack={this.goBack}
                        ref={this.child}
                        {...this.state}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <center className='mt'>
              <ExperimentalPreview />
              <div className='mtbs'>
                {!confirm && (
                  <Button
                    style={{ backgroundColor: '#F4D271', color: '#000' }}
                    onClick={this.confirm}>
                    Delete sheet
                  </Button>
                )}
                {confirm && (
                  <Button
                    style={{ backgroundColor: '#000', color: '#fff' }}
                    onClick={this.removeSheet}>
                    Are you sure?
                  </Button>
                )}
              </div>
            </center>
          </Grid.Column>
          <Grid.Column width='9' style={{ height: '100vh' }}>
            <ScrollArea trackHidden height='100%'>
              {active && !loading ? (
                <div style={{ backgroundColor: '#fafafa', padding: '2vh' }}>
                  <div className='mtbs'>
                    <h2>Main list</h2>
                    <p>You can select up to 3 different columns + 1 for images.</p>
                    <p>For correct usage the sheet should have the first row as headers.</p>
                  </div>
                  <Segment padded basic style={{ backgroundColor: '#fff' }}>
                    <Grid relaxed stackable verticalAlign='middle'>
                      <Grid.Column width='8'>
                        <div
                          style={{
                            height: '100%',
                            overflow: 'visible'
                          }}>
                          <Dropdown
                            upward={false}
                            trigger={val1select}
                            value={selectedValue1}
                            onChange={this.handleValue1}
                            options={columns}
                          />
                          <div className='mtbs'>
                            <Label horizontal>{selectedValue1}</Label>
                          </div>

                          <Dropdown
                            trigger={val2select}
                            value={selectedValue2}
                            onChange={this.handleValue2}
                            options={columns}
                          />
                          <div className='mtbs'>
                            <Label horizontal>{selectedValue2}</Label>
                          </div>
                          <Dropdown
                            trigger={val3select}
                            value={selectedValue3}
                            onChange={this.handleValue3}
                            options={columns}
                          />
                          <div className='mts'>
                            <Label horizontal>{selectedValue3}</Label>
                          </div>
                        </div>
                      </Grid.Column>
                      <Grid.Column width='8'>
                        <div className='mts'>
                          <Dropdown
                            trigger={imageSelect}
                            value={selectedImage}
                            onChange={this.handleImage}
                            options={columns}
                          />
                          <div className='mtbs'>
                            <Label>{selectedImage}</Label>
                          </div>
                          <h4>Layout</h4>
                          <Button.Group className='mts'>
                            <Button
                              content='Wrap'
                              onClick={() => this.sheetLayout('wrap')}
                              style={{
                                backgroundColor: theme === 'wrap' ? '#000' : '#777',
                                color: '#fff',
                                marginRight: '1vh'
                              }}
                              size='small'
                            />
                            <Button
                              content='Float'
                              onClick={() => this.sheetLayout('float')}
                              size='small'
                              style={{
                                backgroundColor: theme === 'float' ? '#000' : '#777',
                                color: '#fff'
                              }}
                            />
                          </Button.Group>
                          <Divider />
                          <Button.Group>
                            <Button
                              onClick={this.saveValues}
                              basic={saved}
                              loading={saving}
                              size='large'
                              style={{
                                marginRight: '1vh',

                                backgroundColor: '#73A3D4',
                                color: '#fff'
                              }}>
                              <Icon name='save' />
                              Save list
                            </Button>
                            <Button
                              content='Clear list'
                              onClick={this.clearAll}
                              size='large'
                              style={{ borderColor: '#eee', color: 'red' }}
                              basic
                            />
                          </Button.Group>
                        </div>
                      </Grid.Column>
                    </Grid>
                  </Segment>

                  <div className='mtbs'>
                    <h2>Details screen</h2>
                    <p>Configure your smart components</p>
                  </div>

                  <Segment
                    className='centerX'
                    basic
                    style={{
                      backgroundColor: '#fff',
                      marginTop: 24,
                      minHeight: 300
                    }}>
                    <div>
                      {!selectComp && (
                        <SmartComponents newSmartComp={this.newSmartComp.bind(this)} />
                      )}
                      {selectComp && (
                        <div>
                          {selectSource && (
                            <div className='mtbs'>
                              <Dropdown
                                trigger={trigger}
                                value={newComp}
                                onChange={this.handleNewComp}
                                options={columns}
                              />
                            </div>
                          )}
                          {selectLabel && (
                            <div>
                              <Label>Source: {newComp}</Label>
                              <div className='mtbs'>
                                <Input
                                  fluid
                                  required
                                  type='text'
                                  placeholder='Label'
                                  onChange={this.handleChange}
                                  name='newCompLabel'
                                />
                              </div>
                              <Button.Group>
                                <Button
                                  color='black'
                                  content={!errorComp ? 'Add component' : errorComp}
                                  negative={errorComp}
                                  loading={apiLoading}
                                  style={{ marginRight: '1vh' }}
                                  onClick={this.newComp}
                                />
                                <Button basic color='red' onClick={this.clearSelect}>
                                  Cancel
                                </Button>
                              </Button.Group>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </Segment>
                  <Segment basic fluid padded>
                    <Grid columns={2} stackable>
                      {components}
                    </Grid>
                  </Segment>
                </div>
              ) : null}
            </ScrollArea>
          </Grid.Column>
          <Grid.Column width='1' />
        </Grid>
      </div>
    )
  }
}
